import {
  ExtraLabelDisplayFn,
  UnitDisplayPropertiesFn,
} from 'features/siteMapViz'
import { isNil } from 'lodash'
import { useSiteModelContext } from 'pages/siteView/siteMap/contexts/SiteModelContext'
import { MapInteractionAPIs } from 'pages/siteView/siteMap/SiteViewMap'
import { TilesetMapFeatureDispatch } from 'pages/siteView/siteMap/tilesetMap/features/TilesetMapFeatureDispatch'
import React, { ReactNode } from 'react'
import { GeckoGeographicPin } from 'types'

import { GeographicPins } from './GeographicPins'

interface TilesetMapFeaturesProps {
  shouldDisplayTaggedUnit: NonNullable<
    MapInteractionAPIs['shouldDisplayTaggedUnit']
  >
  getUnitDisplayName: (unitID: string) => string | undefined
  showUntaggedModels: boolean
  getUnitDisplayProperties: UnitDisplayPropertiesFn
  getExtraLabelDisplay: ExtraLabelDisplayFn
  pins: readonly GeckoGeographicPin[]
}
export const TilesetMapFeatures: React.FC<TilesetMapFeaturesProps> = (
  props
) => {
  const { siteModel } = useSiteModelContext()

  const {
    showUntaggedModels,
    shouldDisplayTaggedUnit,
    getUnitDisplayProperties,
    getUnitDisplayName,
  } = props
  const features = React.useMemo(() => {
    const featureComponents = new Array<ReactNode>()
    for (const key in siteModel.data.features) {
      const feature = siteModel.data.features[key]
      feature.id = key

      const visible = !feature.unit_id
        ? showUntaggedModels
        : (shouldDisplayTaggedUnit(feature.unit_id) ?? showUntaggedModels)

      featureComponents.push(
        <TilesetMapFeatureDispatch
          key={key}
          feature={feature}
          featureDisplayName={
            isNil(feature.unit_id)
              ? undefined
              : getUnitDisplayName(feature.unit_id)
          }
          visible={visible}
          getUnitDisplayProperties={getUnitDisplayProperties}
          getExtraLabelDisplay={props.getExtraLabelDisplay}
        />
      )
    }
    return featureComponents
  }, [
    siteModel,
    showUntaggedModels,
    shouldDisplayTaggedUnit,
    getUnitDisplayProperties,
    props.getExtraLabelDisplay,
    getUnitDisplayName,
  ])

  return (
    <group>
      {features.map((f) => f)}
      <GeographicPins pins={props.pins} />
    </group>
  )
}
